import React, { useState } from 'react';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import {
  Box,
  Button,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { getStructureReport } from 'js/actions/reportsActions';

const useStyles = makeStyles(styles);

export default function CorporateReport() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const corporatives = useSelector((state) => state.corporatives.corporatives);

  const [corporative, setCorporative] = useState();
  const [blocking, setBlocking] = useState();

  const onSubmit = () => {
    if (!corporative) {
      Swal.fire({
        title: '',
        text: 'Se requiere seleccionar todos los campos para generar el reporte',
        icon: 'warning',
      });
      return;
    }
    setBlocking(true);
    dispatch(getStructureReport(endBlocking, corporative));
  };

  function endBlocking() {
    setBlocking(false);

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: 'Reporte Generado Correctamente',
    });
  }

  const handleCorporative = (corporative) => {
    setCorporative(corporative.target.value);
  };

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        bgcolor: 'white',
        p: 4,
        borderRadius: 1,
        boxShadow: 1,
      }}
      width="100%"
    >
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid2 container={true} spacing={3}>
          <Grid2 size={{ lg: 6, md: 12, xs: 12 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel>
                {intl.formatMessage({
                  id: 'app.reports.corpStructure.corpLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('corporative')}
                labelId="demo-simple-select-outlined-label"
                name="corporative"
                onChange={handleCorporative}
                value={corporative}
                required
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.corpStructure.corpLbl',
                    })}
                  />
                }
              >
                {shortCorporatives().map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 6, md: 12, xs: 12 }}>
            <Button
              className={classes.signUpButton}
              color="primary"
              size="large"
              type="submit"
              loading={blocking}
              variant="contained"
              loadingPosition="start"
            >
              {blocking
                ? 'Cargando...'
                : intl.formatMessage({
                    id: 'app.reports.corpStructure.downloadBtn',
                  })}
            </Button>
          </Grid2>
        </Grid2>
      </form>
    </Box>
  );
}
